<template>
  <div class="opc-pbx__0abj" @click='onValidateClick' v-html="$t('billing.pbx.validate_your_0ABJ_address_instantly')"></div>
</template>
<script>
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import Validate0ABJ from '@/plans/ZOOM_PHONE/component/dialog/validate-0ABJ.vue';

export default {
  name: '0ABJ',
  created() {
    this.validate0ABJDialog = new ServiceConfirm(Validate0ABJ);
  },
  methods: {
    async onValidateClick(event) {
      if (event?.target?.tagName === 'A') {
        this.$tracking.buyInteraction('zoom phone validate your 0ABJ address instantly', 'validate your 0ABJ address instantly');
        await this.validate0ABJDialog.confirm();
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.opc-pbx__0abj {
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 150%;
  color: #666487;
  margin-top: 24px;
}
</style>
